// extracted by mini-css-extract-plugin
export default {"header":"reports-details_header__j2Zn2","btnText":"reports-details_btnText__4oWeb"};